import { proxy } from 'valtio'
import type { PointInsufficientScenario } from './commercial-access'
export { memberUpgradeDialogStore, openMemberUpgradeDialog, closeMemberUpgradeDialog } from '@/shared/lib/member-upgrade-store'

interface PointInsufficientDialogState {
  open: boolean
  scenario: PointInsufficientScenario
  teamId: string
  message: string
}

interface TeamCommercialDialogState {
  pointInsufficient: PointInsufficientDialogState
}

const DEFAULT_POINT_INSUFFICIENT_STATE: PointInsufficientDialogState = {
  open: false,
  scenario: 'buy_or_upgrade',
  teamId: '',
  message: '',
}

export const teamCommercialDialogStore = proxy<TeamCommercialDialogState>({
  pointInsufficient: { ...DEFAULT_POINT_INSUFFICIENT_STATE },
})

export function openPointInsufficientDialog(payload?: {
  scenario?: PointInsufficientScenario
  teamId?: string
  message?: string
}) {
  teamCommercialDialogStore.pointInsufficient = {
    open: true,
    scenario: payload?.scenario ?? DEFAULT_POINT_INSUFFICIENT_STATE.scenario,
    teamId: payload?.teamId?.trim() ?? '',
    message: payload?.message?.trim() ?? '',
  }
}

export function closeTeamCommercialDialog() {
  teamCommercialDialogStore.pointInsufficient.open = false
}
